<div class="my-container">
  <div class="top-wrapper is-flex has-flex-content-center">
    <a class="navbar-brand" href="#">
      <img height="23" width="123" src="{{'/assets/REMAX_Logo/REMAX_masterLogo@1x.svg' | staticp}}" alt="REMAX Logo"/>
    </a>
  </div>
  <div *ngIf="!isTokenValid" class="error text-center" translate="reset-password.invalid-token"></div>
  <div *ngIf="isTokenValid" class="top">
    <h3 class="title"><b translate="reset-password.reset-password"></b></h3>
    <div class="welcome-back" translate="reset-password.welcome-back"></div>

    <form class="form" (ngSubmit)="onSubmit()" [formGroup]="registrationForm">
      <app-input pattern="^.{6,}$"
        label="{{'registration.password' | translate}}" [inputType]="showPasswordText ? 'text': 'password'"
        [parentFormGroup]="registrationForm" [formControl]="registrationForm.get('password')"
        [class.has-errors]="this.registrationForm.invalid && (this.registrationForm.dirty || this.registrationForm.touched)"
        inputId="input-reset-password">
        <span [class.hidden]="!registrationForm.get('password').value" class="show-hide form-control-feedback-text" (click)="showPasswordText = !showPasswordText">
          {{ (showPasswordText ? 'form.hide' : 'form.show') | translate }}
        </span>
      </app-input>
      <app-input pattern="^.{6,}$"
      label="{{'registration.confirm-password' | translate}}" [inputType]="showConfirmPasswordText ? 'text': 'password'"
      [parentFormGroup]="registrationForm" [formControl]="registrationForm.get('confirmPassword')"
      [class.has-errors]="this.registrationForm.invalid && (this.registrationForm.dirty || this.registrationForm.touched)"
      inputId="input-reset-confirm-password">
        <span [class.hidden]="!registrationForm.get('confirmPassword').value" class="show-hide form-control-feedback-text" (click)="showConfirmPasswordText = !showConfirmPasswordText">
          {{ (showConfirmPasswordText ? 'form.hide' : 'form.show') | translate }}
        </span>
        <p class="error-clue" *ngIf="this.registrationForm.invalid && (this.registrationForm.dirty || this.registrationForm.touched)">Passwords don't match</p>
      </app-input>
      <button class="btn btn-primary btn-full-sized" type="submit" [disabled]="!registrationForm.valid" translate="reset-password.reset-password"></button>
    </form>
  </div>
</div>
